import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../Config";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea"; // Para observaciones
import QrReader from "../components/QrReader.tsx";
import { Dropdown } from "primereact/dropdown";
import { obtenerPeriodoActual } from "../utilities/DateUtil.js";
import CapturePhoto from "../components/Camara.js"; // Importar el componente CapturePhoto
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";

const Lectura = (props) => {
  const { baseUrl, headerText } = useGlobalContext();
  const [loading, setLoading] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [lectura, setLectura] = useState("");
  const [estadoMedidor, setEstadoMedidor] = useState("OK");
  const [qrDialogVisible, setQrDialogVisible] = useState(false);
  const [manualDialogVisible, setManualDialogVisible] = useState(false);
  const [captureDialogVisible, setCaptureDialogVisible] = useState(false);
  const [scannedData, setScannedData] = useState("");
  const [idMedidor, setIdMedidor] = useState(null);
  const [medidor, setMedidor] = useState(null);
  const [periodo, setPeriodo] = useState("");
  const [mostrarLecturaInput, setMostrarLecturaInput] = useState(true);
  const [mensajeAlerta, setMensajeAlerta] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [mensajeLectura, setMensajeLectura] = useState("");
  const [capturedImage, setCapturedImage] = useState(null);
  const [showCapturedImage, setShowCapturedImage] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const [medidoresEncontrados, setMedidoresEncontrados] = useState([]);
  const [busquedaDescripcion, setBusquedaDescripcion] = useState("");
  const [busquedaDireccion, setBusquedaDireccion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [promedioConsumo, setPromedioConsumo] = useState(null);
  const [guardando, setGuardando] = useState(false);

  const idUsuario = sessionStorage.getItem("id");
  const [confirmDuplicadoVisible, setConfirmDuplicadoVisible] = useState(false);
  const [mensajeDuplicado, setMensajeDuplicado] = useState("");
  const [payloadPendiente, setPayloadPendiente] = useState(null);

  const dropdownOptions = [
    { label: "OK", value: "OK" },
    { label: "NOK", value: "NOK" },
  ];

  const openQrDialog = () => {
    handleCancelar();
    setQrDialogVisible(true);
  };

  const closeQrDialog = () => {
    setQrDialogVisible(false);
  };

  const openManualDialog = () => {
    setManualDialogVisible(true);
  };

  const closeManualDialog = () => {
    setManualDialogVisible(false);
    setBusqueda("");
    setMedidoresEncontrados([]);
  };

  const openCaptureDialog = () => {
    setCaptureDialogVisible(true); // Mostrar el diálogo de captura de foto
  };

  const closeCaptureDialog = () => {
    setCaptureDialogVisible(false); // Ocultar el diálogo de captura de foto
  };

  const handleScanSuccess = (result) => {
    setScannedData(result);
    closeQrDialog();
    fetchMedidor(result);
  };

  const handleCancelar = () => {
    setInputValue("");
    setLectura("");
    setEstadoMedidor("OK"); // Reinicia el estado del medidor
    setScannedData("");
    setIdMedidor(null);
    setMedidor(null);
    setMostrarLecturaInput(true); // Resetea la visibilidad del InputText
    setMensajeAlerta("");
    setObservaciones(""); // Resetea las observaciones
    setMensajeLectura(""); // Resetea el mensaje de la lectura
    setCapturedImage(null); // Resetea la imagen capturada
    setBusqueda("");
    setMedidoresEncontrados([]);
    setBusquedaDescripcion(""); // Limpia la descripción de la búsqueda
    setBusquedaDireccion(""); // Limpia la dirección de la búsqueda
    setIsLoading(false); // Reinicia el estado de carga
    setPromedioConsumo(null); // Limpia el promedio de consumo
  };

  const handleBuscarMedidores = async () => {
    if (!busquedaDescripcion && !busquedaDireccion) {
      alert(
        "Debe ingresar al menos un término de búsqueda (descripción o dirección).",
      );
      return;
    }
    setIsLoading(true);

    const endpoint = `${baseUrl}getConsultaMedidorManual?descripcion=${encodeURIComponent(
      busquedaDescripcion.toUpperCase(),
    )}&direccion=${encodeURIComponent(busquedaDireccion.toUpperCase())}`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        credentials: "include",
        redirect: "follow",
        headers: headerText,
      });

      const data = await response.json();

      if (!response.ok || !data.respuesta) {
        throw new Error(data.mensaje || "No se encontraron medidores.");
      }

      setMedidoresEncontrados(data.medidores); // Guarda los resultados
    } catch (error) {
      alert("Error en la búsqueda de medidores: " + error.message);
    } finally {
      setIsLoading(false); // Desactiva el spinner
    }
  };

  const calcularPromedioConsumo = async () => {
    if (!medidor || !medidor.domicilioCodigo || !medidor.tipo?.descripcion) {
      console.error(
        "El medidor no tiene un código de domicilio o tipo válido.",
      );
      return;
    }

    const endpointLecturas = `${baseUrl}getUltimasLecturas?codigoDomicilio=${encodeURIComponent(
      medidor.domicilioCodigo,
    )}&tipo=${encodeURIComponent(medidor.tipo.descripcion)}`;

    try {
      const response = await fetch(endpointLecturas, {
        method: "GET",
        credentials: "include",
        redirect: "follow",
        headers: headerText,
      });

      const data = await response.json();

      if (
        !response.ok ||
        !data.respuesta ||
        !Array.isArray(data.lecturas) ||
        data.lecturas.length === 0
      ) {
        throw new Error(data.mensaje || "No se pudieron obtener las lecturas.");
      }

      const lecturas = data.lecturas
        .map((l) => parseInt(l, 10))
        .filter((l) => !isNaN(l));
      const sumaLecturas = lecturas.reduce((acc, val) => acc + val, 0);
      const promedio = Math.round(sumaLecturas / lecturas.length);

      setPromedioConsumo(promedio); // Actualiza el estado del promedio
    } catch (error) {
      console.error(
        "Error al obtener lecturas para calcular promedio: ",
        error.message,
      );
      setPromedioConsumo(null); // Limpia el promedio en caso de error
    }
  };

  useEffect(() => {
    if (medidor) {
      calcularPromedioConsumo();
    }
  }, [medidor]);

  const handleGuardar = async () => {
    setGuardando(true);
    // Validar estadoMedidor
    if (!estadoMedidor) {
      alert("Por favor, seleccione un estado para el medidor.");
      return;
    }

    // Validar observaciones y foto si el estado es NOK
    if (estadoMedidor === "NOK") {
      if (!observaciones || !observaciones.trim()) {
        alert("Por favor, ingrese observaciones para el estado NOK.");
        return;
      }

      if (!capturedImage) {
        alert("Por favor, capture una imagen para el estado NOK.");
        return;
      }
    }

    // Validar medidor y sus propiedades
    if (
      !medidor ||
      medidor.lecturaActual === null ||
      medidor.lecturaActual === undefined ||
      !medidor.tipo ||
      !medidor.unidadMedida
    ) {
      alert(
        "Los datos del medidor están incompletos. Por favor, revise la información.",
      );
      return;
    }

    let consumo = 0;
    let lecturaFinal = lectura ? parseInt(lectura, 10) : null;
    let lecturaInicial =
      medidor.lecturaActual !== null && medidor.lecturaActual !== undefined
        ? parseInt(medidor.lecturaActual, 10)
        : 0;

    // Validar lecturaInicial y lecturaFinal
    if (
      (lecturaFinal === null || isNaN(lecturaFinal)) &&
      estadoMedidor === "OK"
    ) {
      alert("Por favor, ingrese una lectura final válida.");
      return;
    }

    if (
      (lecturaInicial === null || isNaN(lecturaInicial)) &&
      estadoMedidor === "OK"
    ) {
      alert("La lectura inicial del medidor es inválida.");
      return;
    }

    if (estadoMedidor === "OK") {
      // Estado OK: Calculamos el consumo normalmente
      consumo = lecturaFinal - lecturaInicial;
      if (consumo < 0) {
        //alert(
        //"La lectura ingresada no puede ser menor que la lectura anterior. Por favor, ingrese un valor válido."
        //);
        alert(
          "AVISO: La lectura guardada es menor a la registrada el mes anterior .",
        );
        //return;
      }
    } else if (estadoMedidor === "NOK") {
      // Estado NOK: Obtenemos las últimas 6 lecturas y calculamos el promedio
      const endpointLecturas = `${baseUrl}getUltimasLecturas?codigoDomicilio=${encodeURIComponent(
        medidor.domicilioCodigo,
      )}&tipo=${encodeURIComponent(medidor.tipo.descripcion)}`;

      try {
        const response = await fetch(endpointLecturas, {
          method: "GET",
          credentials: "include",
          redirect: "follow",
          headers: headerText,
        });
        const data = await response.json();

        if (
          !response.ok ||
          !data.respuesta ||
          !Array.isArray(data.lecturas) ||
          data.lecturas.length === 0
        ) {
          throw new Error(
            data.mensaje || "No se pudieron obtener las lecturas.",
          );
        }

        const lecturas = data.lecturas
          .map((l) => parseInt(l, 10))
          .filter((l) => !isNaN(l));
        const sumaLecturas = lecturas.reduce((acc, val) => acc + val, 0);
        consumo = Math.round(sumaLecturas / lecturas.length);

        // Caso NOK, lectura inicial y final son iguales
        lecturaFinal = lecturaInicial;
      } catch (error) {
        alert(
          "Error al obtener lecturas para calcular promedio: " + error.message,
        );
        return;
      }
    }

    // Procesar la imagen capturada
    let tipoArchivo = "";
    let archivo = "";
    if (capturedImage) {
      const [fileType, base64Data] = capturedImage.split(",");
      tipoArchivo = fileType ? fileType.split(":")[1] : "";
      archivo = base64Data || "";
    }

    // Validar las propiedades esenciales del medidor
    if (!medidor.id || !medidor.empresa || !medidor.empresa.id) {
      alert("Faltan datos esenciales del medidor o de la empresa.");
      return;
    }

    const payload = {
      idMedidor: medidor.id,
      idEmpresa: medidor.empresa.id,
      idUsuario: Number(idUsuario),
      clienteNombre: medidor.clienteNombre || "",
      codigoDomicilio: medidor.domicilioCodigo || "",
      domicilio: medidor.domicilioDescripcion || "",
      periodoMedicion: periodo || "",
      tipo: medidor.tipo.descripcion || "",
      lecturaInicial: lecturaInicial,
      lecturaFinal: lecturaFinal,
      consumo: consumo,
      unidadMedida: medidor.unidadMedida.descripcion || "",
      estadoMedidor: estadoMedidor || "",
      observacion: observaciones || "",
      tipoArchivo: tipoArchivo,
      archivo: archivo,
      forzarInsercion: false,
    };

    const endpoint = `${baseUrl}guardarDetallePeriodo`;

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      const text = await response.text();
      let data = {};
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Respuesta no válida del servidor.");
      }

      // ✅ Caso duplicado: 409 + requiereConfirmacion
      if (response.status === 409 || data?.requiereConfirmacion) {
        setMensajeDuplicado(
          data?.mensaje ||
            "Ya existe una lectura para este periodo. ¿Desea continuar bajo su responsabilidad?",
        );
        setPayloadPendiente(payload);
        setConfirmDuplicadoVisible(true);
        return;
      }

      if (data.respuesta) {
        alert("Se ha registrado el medidor correctamente");
        handleCancelar();
      } else {
        alert("Error en el guardado: " + (data.mensaje || "Error desconocido"));
      }
    } catch (error) {
      alert("Error en el guardado: " + error.message);
    } finally {
      setGuardando(false);
    }
  };

  const confirmarGuardarDuplicado = async () => {
    if (!payloadPendiente) return;

    setConfirmDuplicadoVisible(false);
    setGuardando(true);

    const endpoint = `${baseUrl}guardarDetallePeriodo`;
    const payloadForzado = { ...payloadPendiente, forzarInsercion: true };

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payloadForzado),
      });

      const text = await response.text();
      let data = {};
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Respuesta no válida del servidor.");
      }

      if (data.respuesta) {
        alert(
          "Lectura registrada (inserción forzada). Recuerde que ya existía una lectura en el periodo.",
        );
        setPayloadPendiente(null);
        handleCancelar();
      } else {
        alert("Error en el guardado: " + (data.mensaje || "Error desconocido"));
      }
    } catch (error) {
      alert("Error en el guardado: " + error.message);
    } finally {
      setGuardando(false);
    }
  };

  const cancelarGuardarDuplicado = () => {
    setConfirmDuplicadoVisible(false);
    setPayloadPendiente(null);
  };

  useEffect(() => {
    setPeriodo(obtenerPeriodoActual());
  }, []);

  const handleSeleccionarMedidor = async (medidorSeleccionado) => {
    setManualDialogVisible(false);

    setLoading(true); // Inicia el loading al comenzar el fetch
    const endpoint = `${baseUrl}getConsultaMedidorById?id=${medidorSeleccionado.id}`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        credentials: "include",
        redirect: "follow",
        headers: headerText,
      });

      console.log(response);
      const data = await response.json();

      if (!response.ok || data.mensaje !== "OK") {
        throw new Error(data.mensaje || "No se pudo encontrar el medidor.");
      }

      setMedidor(data.medidor); // Guarda el objeto completo si todo va bien
    } catch (error) {
      alert(
        "Error al buscar el medidor: " +
          (error.message || "Ha ocurrido un error inesperado."),
      );
      // Limpia la variable scannedData si hay un error
      setScannedData("");
      setIdMedidor(null);
      setMedidor(null); // Limpia el estado del medidor
    } finally {
      setLoading(false); // Finaliza el loading una vez completado el fetch
    }
  };

  const fetchMedidor = async (qrCode) => {
    setLoading(true); // Inicia el loading al comenzar el fetch
    const endpoint = `${baseUrl}getConsultaMedidor?qrCode=${qrCode}`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        credentials: "include",
        redirect: "follow",
        headers: headerText,
      });

      console.log(response);
      const data = await response.json();

      if (!response.ok || data.mensaje !== "OK") {
        throw new Error(data.mensaje || "No se pudo encontrar el medidor.");
      }

      setMedidor(data.medidor); // Guarda el objeto completo si todo va bien
    } catch (error) {
      alert(
        "Error al buscar el medidor: " +
          (error.message || "Ha ocurrido un error inesperado."),
      );

      setScannedData("");
      setIdMedidor(null);
      setMedidor(null);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (scannedData || idMedidor) {
  //     console.log(scannedData);
  //     const fetchMedidor = async () => {
  //       setLoading(true); // Inicia el loading al comenzar el fetch
  //       const endpoint = `${baseUrl}getConsultaMedidor?qrCode=${scannedData}&id=${idMedidor}`;

  //       try {
  //         const response = await fetch(endpoint, {
  //           method: "GET",
  //           credentials: "include",
  //           redirect: "follow",
  //           headers: headerText,
  //         });

  //         console.log(response);
  //         const data = await response.json();

  //         if (!response.ok || data.mensaje !== "OK") {
  //           throw new Error(data.mensaje || "No se pudo encontrar el medidor.");
  //         }

  //         setMedidor(data.medidor); // Guarda el objeto completo si todo va bien
  //       } catch (error) {
  //         alert(
  //           "Error al buscar el medidor: " +
  //             (error.message || "Ha ocurrido un error inesperado.")
  //         );
  //         // Limpia la variable scannedData si hay un error
  //         setScannedData("");
  //         setIdMedidor(null);
  //         setMedidor(null); // Limpia el estado del medidor
  //       } finally {
  //         setLoading(false); // Finaliza el loading una vez completado el fetch
  //       }
  //     };

  //     fetchMedidor();
  //   }
  // }, [scannedData, baseUrl, headerText, idMedidor]);

  const handleEstadoChange = (e) => {
    const value = e.value;
    setEstadoMedidor(value);

    if (value === "OK") {
      setMostrarLecturaInput(true);
      setMensajeAlerta("");

      if (medidor && medidor.tipo) {
        if (medidor.tipo.descripcion === "AGUA") {
          setMensajeLectura("4 dígitos de la izquierda del remarcador");
          setLectura((prevLectura) => (prevLectura || "").substring(0, 4)); // Limitar a 4 dígitos
        } else if (medidor.tipo.descripcion === "ELECTRICIDAD") {
          setMensajeLectura("6 dígitos de la izquierda del remarcador");
          setLectura((prevLectura) => (prevLectura || "").substring(0, 6)); // Limitar a 6 dígitos
        }
      }
    } else if (value === "NOK") {
      setMostrarLecturaInput(false);
      const unidad = medidor?.unidadMedida?.descripcion || "unidad";
      const mensajePromedio =
        promedioConsumo !== null
          ? ` (promedio ${promedioConsumo} ${unidad})`
          : "";

      setMensajeAlerta(
        `Este mes se registrará el consumo promedio de los últimos 6 meses${mensajePromedio}.`,
      );
    }
  };

  const handleLecturaChange = (e) => {
    let value = e.target.value;

    if (medidor && medidor.tipo) {
      if (medidor.tipo.descripcion === "AGUA") {
        value = value.slice(0, 4); // Limitar a 4 dígitos
      } else if (medidor.tipo.descripcion === "ELECTRICIDAD") {
        value = value.slice(0, 6); // Limitar a 6 dígitos
      }
    }

    setLectura(value);
  };

  const handleCapture = (imageSrc) => {
    setCapturedImage(imageSrc);
    setShowCapturedImage(false);
  };

  const toggleShowCapturedImage = () => {
    setShowCapturedImage((prev) => !prev); // Cambia el estado para mostrar/ocultar la imagen
  };

  return (
    <div className="col-12 md:col-12">
      {!medidor && (
        <div
          style={{
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              //marginBottom: "5px",
            }}
          >
            <h4 style={{ margin: 0, color: "#495057" }}>
              Lectura de medidores
            </h4>
            <h5 style={{ margin: 0, color: "#6c757d" }}>Periodo {periodo}</h5>
          </div>
          <div
            style={{
              padding: "20px",
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
            }}
          >
            <h5
              style={{
                borderBottom: "2px solid #ced4da",
                paddingBottom: "10px",
                marginBottom: "20px",
                color: "#495057",
              }}
            >
              Seleccione un método de registro:
            </h5>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "20px",
              }}
            >
              <Button
                type="button"
                onClick={openQrDialog}
                label="Escanear Código QR"
                icon="pi pi-qrcode"
                className="p-button"
                style={{
                  width: "250px",
                  backgroundColor: "#007bff",
                  borderColor: "#007bff",
                  color: "#fff",
                  padding: "10px 20px",
                  fontSize: "14px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
              <Button
                type="button"
                onClick={openManualDialog}
                label="Ingreso Manual"
                icon="pi pi-book"
                className="p-button-success"
                style={{
                  width: "250px",
                  backgroundColor: "#28a745",
                  borderColor: "#28a745",
                  color: "#fff",
                  padding: "10px 20px",
                  fontSize: "14px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </div>
          </div>
        </div>
      )}
      {!loading && medidor && (
        <div
          style={{
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
            marginBottom: "20px",
          }}
        >
          <h5
            style={{
              borderBottom: "2px solid #ced4da",
              paddingBottom: "10px",
              marginBottom: "20px",
              color: "#495057",
            }}
          >
            Remarcador encontrado:
          </h5>
          <div className="grid" style={{ marginBottom: "20px" }}>
            <div className="col-6" style={{ paddingRight: "10px" }}>
              <p>
                <strong>Domicilio:</strong>{" "}
                {medidor?.domicilioDescripcion || "N/A"}
              </p>

              <p>
                <strong>Cliente:</strong> {medidor?.clienteNombre || "N/A"}
              </p>
              <p>
                <strong>Lectura Anterior:</strong>{" "}
                {medidor?.lecturaActual || "0"}
              </p>
            </div>
            <div className="col-6" style={{ paddingLeft: "10px" }}>
              <p>
                <strong>Tipo:</strong> {medidor?.tipo?.descripcion || "N/A"}
              </p>
              <p>
                <strong>Dirección:</strong>{" "}
                {medidor?.domicilioDireccion || "N/A"}
              </p>
              <p>
                <strong>Empresa:</strong> {medidor?.empresa?.nombre || "N/A"}
              </p>
            </div>
          </div>
          <h5
            style={{
              borderBottom: "2px solid #ced4da",
              paddingBottom: "10px",
              marginBottom: "20px",
              color: "#495057",
            }}
          >
            Ingrese la medición:
          </h5>
          <div style={{ marginBottom: "20px" }}>
            {estadoMedidor && (
              <>
                {mostrarLecturaInput && (
                  <>
                    <label
                      htmlFor="numero"
                      style={{
                        fontWeight: "bold",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Lectura Actual:
                    </label>
                    <InputText
                      id="numero"
                      value={lectura}
                      onChange={handleLecturaChange}
                      placeholder="Ingrese lectura"
                      maxLength={medidor?.tipo?.descripcion === "AGUA" ? 4 : 6}
                      inputMode="numeric"
                      pattern="\d*"
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "4px",
                        border: "1px solid #ced4da",
                        marginBottom: "15px",
                      }}
                    />
                    {mensajeLectura && (
                      <p
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          marginTop: "5px",
                        }}
                      >
                        {mensajeLectura}
                      </p>
                    )}
                  </>
                )}

                <label
                  htmlFor="estado"
                  style={{
                    fontWeight: "bold",
                    marginBottom: "5px",
                    display: "block",
                  }}
                >
                  Estado Medidor:
                </label>
                <Dropdown
                  id="estado"
                  value={estadoMedidor}
                  options={dropdownOptions}
                  onChange={handleEstadoChange}
                  style={{
                    width: "100%",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    marginBottom: "15px",
                  }}
                  placeholder="Seleccione un estado"
                />

                {mensajeAlerta && (
                  <p
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      marginTop: "5px",
                    }}
                  >
                    {mensajeAlerta}
                  </p>
                )}

                <label
                  htmlFor="observaciones"
                  style={{
                    fontWeight: "bold",
                    marginBottom: "5px",
                    display: "block",
                  }}
                >
                  Observaciones:
                </label>
                <InputTextarea
                  id="observaciones"
                  value={observaciones}
                  onChange={(e) => setObservaciones(e.target.value)}
                  placeholder="Ingrese observaciones"
                  rows={3}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    marginBottom: "15px",
                  }}
                />
                <Button
                  label="Adjuntar Imagen"
                  icon="pi pi-image"
                  className="p-button-secondary"
                  style={{
                    backgroundColor: "#ffc107",
                    color: "#fff",
                    padding: "10px 20px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    marginBottom: "20px",
                    display: "block",
                  }}
                  onClick={openCaptureDialog}
                />

                {capturedImage && (
                  <div>
                    <Button
                      label="Ver Foto"
                      icon="pi pi-image"
                      className="p-button-info"
                      style={{
                        backgroundColor: "#17a2b8",
                        color: "#fff",
                        padding: "10px 20px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        marginBottom: "10px",
                        display: "block",
                      }}
                      onClick={toggleShowCapturedImage}
                    />
                    {showCapturedImage && (
                      <div>
                        <h5>Foto Capturada:</h5>
                        <img
                          src={capturedImage}
                          alt="Foto Capturada"
                          style={{
                            width: "100%",
                            borderRadius: "8px",
                            marginTop: "10px",
                          }}
                        />
                      </div>
                    )}
                    <Dialog
                      header="Captura de Foto"
                      visible={captureDialogVisible}
                      style={{ width: "100vw" }}
                      onHide={closeCaptureDialog}
                    >
                      <CapturePhoto
                        onClose={closeCaptureDialog}
                        onCapture={handleCapture}
                      />
                    </Dialog>
                  </div>
                )}
              </>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              label={guardando ? "Guardando..." : "Guardar"}
              icon={guardando ? "pi pi-spin pi-spinner" : "pi pi-save"}
              className="p-button-success"
              style={{
                backgroundColor: "#28a745",
                color: "#fff",
                padding: "10px 20px",
                fontSize: "14px",
                borderRadius: "4px",
                flex: 1,
                marginRight: "10px",
              }}
              onClick={handleGuardar}
            />
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="p-button-danger"
              style={{
                backgroundColor: "#dc3545",
                color: "#fff",
                padding: "10px 20px",
                fontSize: "14px",
                borderRadius: "4px",
                flex: 1,
                marginLeft: "10px",
              }}
              onClick={handleCancelar}
              disabled={guardando}
            />
          </div>
        </div>
      )}

      {loading && scannedData && (
        <div>
          <p>Cargando información del medidor...</p>
        </div>
      )}

      <Dialog
        header="Escanear Código QR"
        visible={qrDialogVisible}
        style={{ width: "100vw" }}
        onHide={closeQrDialog}
      >
        <QrReader onScanSuccess={handleScanSuccess} />
      </Dialog>

      <Dialog
        header="Ingreso Manual"
        visible={manualDialogVisible}
        style={{ width: "85vw" }}
        onHide={closeManualDialog}
      >
        <div className="col-12 md:col-12">
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <ProgressSpinner />
            </div>
          ) : (
            <div className="dialog-content">
              <div className="input-section">
                <label htmlFor="manualDescripcion" className="input-label">
                  Descripción:
                </label>
                <InputText
                  id="manualDescripcion"
                  value={busquedaDescripcion}
                  placeholder="Ej: BODEGA"
                  onChange={(e) => setBusquedaDescripcion(e.target.value)}
                  className="input-text"
                  autoComplete={false}
                />
                <small className="input-helper">
                  Ingrese una descripción para buscar medidores.
                </small>
              </div>

              <div className="input-section">
                <label htmlFor="manualDireccion" className="input-label">
                  Dirección:
                </label>
                <InputText
                  id="manualDireccion"
                  value={busquedaDireccion}
                  placeholder="Ej: Calle Falsa 123"
                  onChange={(e) => setBusquedaDireccion(e.target.value)}
                  className="input-text"
                  autoComplete={false}
                />
                <small className="input-helper">
                  Ingrese una dirección para buscar medidores.
                </small>
              </div>

              <div className="button-section">
                <Button
                  label="Buscar"
                  icon="pi pi-search"
                  onClick={handleBuscarMedidores}
                  className="p-button-success button-primary"
                />
                <Button
                  label="Cancelar"
                  onClick={closeManualDialog}
                  icon="pi pi-times"
                  className="p-button-danger button-secondary"
                />
              </div>
            </div>
          )}

          {!isLoading && medidoresEncontrados.length > 0 && (
            <DataTable
              value={medidoresEncontrados}
              className="datatable-responsive p-mt-4"
            >
              <Column
                sortable
                field="domicilioDescripcion"
                header="Descripción"
              />
              <Column sortable field="domicilioDireccion" header="Dirección" />
              <Column sortable field="qrCode" header="Código Qr" />

              <Column
                sortable
                field="tipo.descripcion"
                header="Tipo de Medidor"
              />

              <Column
                header="Acción"
                body={(rowData) => (
                  <Button
                    label="Seleccionar"
                    onClick={() => handleSeleccionarMedidor(rowData)}
                    className="p-button-success button-select"
                    icon="pi pi-check"
                  />
                )}
              />
            </DataTable>
          )}
        </div>
      </Dialog>

      <Dialog
        header="Captura de Foto"
        visible={captureDialogVisible}
        style={{ width: "100vw" }}
        onHide={closeCaptureDialog}
      >
        <CapturePhoto onClose={closeCaptureDialog} onCapture={handleCapture} />
      </Dialog>

      <Dialog
        header="Lectura duplicada detectada"
        visible={confirmDuplicadoVisible}
        style={{ width: "90vw", maxWidth: "500px" }}
        onHide={cancelarGuardarDuplicado}
        modal
        closable={!guardando}
      >
        <p style={{ color: "#b00020", fontWeight: "bold" }}>
          {mensajeDuplicado}
        </p>
        <p>
          Si continúa, se registrará una nueva lectura para el mismo periodo.
          Esto puede generar duplicados y afectar los reportes.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            marginTop: "15px",
          }}
        >
          <Button
            label="Cancelar"
            icon="pi pi-times"
            className="p-button-danger"
            onClick={cancelarGuardarDuplicado}
            disabled={guardando}
          />
          <Button
            label="Continuar (bajo mi responsabilidad)"
            icon="pi pi-exclamation-triangle"
            className="p-button-warning"
            onClick={confirmarGuardarDuplicado}
            disabled={guardando}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default Lectura;
